import { Component, OnInit } from '@angular/core';
import { GenericService } from '../../services/generic.service';
import { AggregationService } from '../../services/aggregation.service';
import { applicationConfig } from '../../applicationConfig';
import { PruHttpService } from '../../services/pru-http.service';
import { SessionStorageService } from "../../services/web-storage/session-storage.service"

declare var environment: any;
@Component({
  selector: 'topbucket',
  templateUrl: './topbucket.component.html',
  styleUrls: ['./topbucket.component.scss']
})
export class TopbucketComponent implements OnInit {
  // myData: any;
  compData: any;
  redesign: boolean;
  showTopBucket = false;
  topBucketData: any;
  userRole: string;
  tbCnt: any;
  // loader: boolean;

  constructor(
    public _genericService: GenericService,
    public _aggregationService: AggregationService,
    public _pruHttpService: PruHttpService,
    public _sessionStorageService: SessionStorageService
  ) {
    this.topBucketData = null;
    this.compData = null;
    // this.loader = true;
    this._genericService.spinner = true;
  }

  ngOnInit() {
    this._genericService.toggleObs$.subscribe(res => {
      this.redesign = res;
    });
    if (environment.tbEnabled) {
      this.tbCnt = this.tbCnt ? this.tbCnt : this._sessionStorageService.getItem('tbCnt') ? this._sessionStorageService.getItem('tbCnt', true) : this.tbCnt;
      if (!this.tbCnt) {
        this.getTBWCMCnt();
      }
    }
    this.subscribeToAggregationDone();

  }

  subscribeToAggregationDone() {
    this.compData = null;
    this.topBucketData = null;
    this._aggregationService.aggregationDone.subscribe((res: any) => {
      if (res === 'aggregationDone') {
        this.compData = this._genericService.AggDataArr[0];
        let sessData;
        if(this.tbCnt){
          sessData = this.tbCnt;
        }else{
          sessData = this._sessionStorageService.getItem('userPzn') ? this._sessionStorageService.getItem('userPzn', true) : applicationConfig.fallBackContent;
        }
        
        const sessDataContents = sessData.contents;

        this.topBucketData = [
          sessDataContents[0],
          sessDataContents[1],
          sessDataContents[2]
        ];
        if (this.redesign && this.compData && this.compData.aggVal) {
          const aggregatedValues = this.compData.aggVal.reduce(
            (accumulator, item) => {
              accumulator.push(item.value);
              return accumulator;
            },
            []
          );

          if (aggregatedValues.every(val => val === '0')) {
            this.showTopBucket = false;
          } else {
            this.showTopBucket = true;

            // fill top bucket data for redesign view
            this._genericService.expandView(
              this.compData.contracts[this.compData.contracts.length - 1],
              this.compData.aggVal[0].key
            );
          }
        }

        this._genericService.spinner = false;
      }
    });
  }

  getTBWCMCnt() {
    const wcmUrl = environment.PUBLIC_RENDER_DOMAIN + '/wps/wcm/connect/UCD_Content/SA-EngagementHook/topbucket';
    this._pruHttpService.getWcmContent(wcmUrl)
      .subscribe(data => {
        this.tbCnt = data;
        if (this.tbCnt) { this._sessionStorageService.setItem("tbCnt", this.tbCnt, true); }
      });
  }


  activateSD(sd){
    setTimeout(() => {
      (document.querySelector(sd) as HTMLElement).focus();
    }, 200);
  }
}
